import { CreateLoanFeeRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateCreateLoanFee = makeValidator({
  FieldParser: CreateLoanFeeRow,
});
